export default "__VITE_ASSET__6Fd7ojBQ__"